/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { FC } from 'react';
import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Text from './Text';
import Button from './Button';
import { RootState } from 'src/store';
import { TEMPLATES_EDITOR_REGARCY } from 'src/constants/templates';
import EditMulti from 'src/components/editor/EditMultiRegurcy';
import SwitchAutoRolling from 'src/components/editor/SwitchAutoRolling';
import EditButtonType from 'src/components/editor/EditButtonType';
import EditBgDimmed from 'src/components/editor/EditBgImageBlur/EditBgImageBlur';
import SwitchDarkMode from 'src/components/editor/SwitchDarkMode';
import { TEMPLATES_EDITOR_GUIDE } from 'src/constants/templatesGuide';
import SwitchSlidePosition from 'src/components/editor/SwitchSlidePosition';
import SwitchImageType from 'src/components/editor/SwitchImageType';
import SwitchMediaType from 'src/components/editor/SwitchMediaType';

const useStyles = makeStyles(() => ({
  root: {
    width: '22rem',
    minWidth: '22rem',
    position: 'relative'
  },
  tabScroll: {
    width: '22rem',
    minWidth: '22rem',
    height: 'calc(100vh - 6.94rem)',

    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    backgroundColor: '#ffffff',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tabsWrapper: {
    width: '100%',
    minHeight: '3.94rem',

    backgroundColor: '#fff'
  },
  tabs: {
    minHeight: '3.94rem',
    padding: '0 1rem',

    display: 'flex',
    // overflowX: 'scroll',
    gap: '1rem',

    color: '#bebebe',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },

  actTab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    color: '#000',
    fontWeight: 700,
    letterSpacing: '0.02em'
  },
  tab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    fontWeight: 700,
    letterSpacing: '0.02em'
  },
  guideTabWrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  actGuideTab: {
    width: '100%',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    borderBottom: '2px solid #000',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '5px'
  },
  guideTab: {
    width: '100%',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#9B9B9B',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '5px'
  }
}));

const NavRight: FC = () => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState<string>('contents');
  const [currentGuideTap, setCurrentGuideTap] = useState<number>(0);
  let currentTemplate = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const tabs = [
    { value: 'contents', label: 'CONTENTS' },
    { value: 'button', label: 'BUTTON' },
    { value: 'guide', label: 'GUIDE' }
  ];

  const handleTabsChange = (value: string): void => {
    setCurrentTab(value);
  };

  const handleGuideChange = (value: number): void => {
    setCurrentGuideTap(value);
  };

  const guide = TEMPLATES_EDITOR_GUIDE?.[currentTemplate]?.guide;
  const multiGuide = guide?.multiGuide;

  return (
    <div className={classes.root}>
      <div className={classes.tabsWrapper}>
        <div className={classes.tabs}>
          {tabs.map(tab => (
            <div
              key={tab.value}
              className={
                currentTab === tab.value ? classes.actTab : classes.tab
              }
              onClick={() => handleTabsChange(tab.value)}
            >
              {tab.value.toUpperCase()}
            </div>
          ))}
        </div>
        <Divider />
      </div>
      <Grid className={classes.tabScroll}>
        <Box>
          {currentTab !== 'guide' && (
            <>
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.multi && (
                <>
                  <EditMulti />
                  <SwitchAutoRolling />
                </>
              )}
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.dimmed && (
                <EditBgDimmed
                  menuTitle={'BACKGROUND OPACITY'}
                  type={'bgDimmed'}
                  max={100}
                />
              )}
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text?.convert && (
                <EditButtonType />
              )}
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.darkMode && (
                <>
                  <SwitchDarkMode />
                  <SwitchSlidePosition />
                </>
              )}
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text
                ?.switchImageType && <SwitchImageType />}
              {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text
                ?.switchMediaType && <SwitchMediaType />}
            </>
          )}
          {currentTab === 'contents' &&
            TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text && (
              <Text datas={TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text} />
            )}
          {currentTab === 'button' &&
            TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.button && (
              <Button
                datas={TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.button}
              />
            )}
          {currentTab === 'guide' &&
            TEMPLATES_EDITOR_GUIDE?.[currentTemplate]?.guide && (
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '28px 16px 0px 16px'
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginRight: '16px'
                    }}
                  >
                    Image Type
                  </span>
                  <span style={{ fontSize: '14px' }}>
                    {
                      TEMPLATES_EDITOR_GUIDE?.[currentTemplate]?.guide
                        ?.imageType
                    }
                  </span>
                </div>
                {!multiGuide ? (
                  <img
                    style={{ width: '100%', marginTop: '17px' }}
                    src={require(`src/images/template_guide/${currentTemplate
                      .toLowerCase()
                      .split(' ')
                      .join('-')}.webp`)}
                    alt="template_guide"
                  />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      marginTop: '20px'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {multiGuide.map((guide: string, idx: number) => (
                        <div
                          key={idx}
                          style={{
                            display: 'flex',
                            width: '100%'
                          }}
                        >
                          <div className={classes.guideTabWrapper}>
                            <div
                              className={
                                currentGuideTap === idx
                                  ? classes.actGuideTab
                                  : classes.guideTab
                              }
                              onClick={() => handleGuideChange(idx)}
                            >
                              {guide}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div>
                      <img
                        style={{ width: '100%' }}
                        src={require(`src/images/template_guide/${currentTemplate
                          .toLowerCase()
                          .split(' ')
                          .join('-')}-${currentGuideTap}.webp`)}
                        alt="template_guide"
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
        </Box>
      </Grid>
    </div>
  );
};

export default NavRight;
